import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

export default new Router({
  routes: [{
      path: '/',
      name: 'home',
      component: resolve => require(['./views/Home.vue'], resolve)
    },
    {
      path: '/aiPage',
      name: 'aiPage',
      component: resolve => require(['./views/AiSoundPage.vue'], resolve)
    },
    {
      path: '/join',
      name: 'join',
      component: resolve => require(['./views/JoinUs.vue'], resolve)
    },
    {
      path: '/production',
      name: 'production',
      component: resolve => require(['./views/Production.vue'], resolve)
    },
    {
      path: '/about',
      name: 'about',
      component: resolve => require(['./views/About.vue'], resolve)
    },
    {
      path: '/scenarios',
      name: 'scenarios',
      component: resolve => require(['./views/Scenarios.vue'], resolve)
    },
    {
      path: '/case1',
      name: 'case1',
      component: resolve => require(['./views/Case1.vue'], resolve)
    },
    {
      path: '/case2',
      name: 'case2',
      component: resolve => require(['./views/Case2.vue'], resolve)
    },
    {
      path: '/case3_1',
      name: 'case3_1',
      component: resolve => require(['./views/Case3-1.vue'], resolve)
    },
    {
      path: '/case3_2',
      name: 'case3_2',
      component: resolve => require(['./views/Case3-2.vue'], resolve)
    },
    {
      path: '/case3_3',
      name: 'case3_3',
      component: resolve => require(['./views/Case3-3.vue'], resolve)
    },
    {
      path: '/case4',
      name: 'case4',
      component: resolve => require(['./views/Case4.vue'], resolve)
    }
  ]
});